import React, { memo, useEffect, useState, useRef, useMemo } from "react";
import { TextField, Autocomplete } from "@mui/material";
import styled from "styled-components";
import debounce from "lodash.debounce";

const StyledAutocomplete = styled(Autocomplete)`
  text-align: left;
  width: 100%;

  & .MuiAutocomplete-inputRoot {
    height: 30px;
    padding: 2px 0px 2px 8px;
  }
  & .MuiAutocomplete-input {
    height: 0px;
    font: normal normal 550 14px/19px Open Sans;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
    align-items: center;
    text-transform: capitalize;
  }
`;

const useDebounce = (callback) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, 1000);
  }, []);

  return debouncedCallback;
};

const ScrollableTypeSelect = ({
  dataOptions,
  setDataOptions =() => {},
  control,
  setControl,
  disabled = false,
  dataPage = 1,
  loadData = () => {},
  prevLevelVal,
}) => {
  const [page, setPage] = useState(1);
  const [options, setOptions] = useState([]);
  const [isFullDataLoad, setIsFullDataLoad] = useState(false);
  const [searchInput, setSearchInput] = useState("")
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setIsFullDataLoad(false)
    if(page === 1){
        setOptions(dataOptions);
    }
  }, [dataOptions]);

  const handleChange = (event, newValue) => {
    setControl(newValue);
  };

  const loadOnSearch = async(val) =>{
    let items = []
    
    const response = await loadData(prevLevelVal, false,1, searchInput);
    if(response?.items?.length === 0){
        setIsFullDataLoad(true)
    }else{
       setPage(1);
       items = response?.items || []
       setOptions([ ...items]);
    }
  }

  const debouncedOnChange = useDebounce(loadOnSearch);

  const handleInputChange = (event, newInputValue) => {
      debouncedOnChange();
      setSearchInput(newInputValue);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPage(dataPage)
    setDataOptions(options)
  };

  const loadMoreResults = async () => {
    const nextPage = page + 1;
    let items = []
    
    const response = await loadData(prevLevelVal, false, nextPage, searchInput);
    if(response?.items?.length === 0){
        setIsFullDataLoad(true)
    }else{
       setPage(nextPage);
       items = response?.items || []
       setOptions([...options, ...items]);
    }
  };

  const handleScroll = (event) => {
    const listboxNode = event.currentTarget;

    const position = listboxNode.scrollTop + listboxNode.clientHeight;
    if (listboxNode.scrollHeight - position <= 1 && !isFullDataLoad) {
      loadMoreResults();
    }
  };

  return (
    <StyledAutocomplete
      value={control || ""}
      onChange={handleChange}
      options={options}
      autoHighlight
      getOptionLabel={(option) => option}
      onInputChange={handleInputChange}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      id="type-select"
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
      ListboxProps={{
        onScroll: handleScroll,
      }}
    />
  );
};

export default memo(ScrollableTypeSelect);
